<div class="modal-header">
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>

<div class="modal-body">
  <div class="ipr-content" [innerHtml]="iprContent"></div>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" type="button" (click)="onClose()">
    {{ 'Close' | translate }}
  </button>
</div>
